import { Component, OnInit, Renderer2 , ElementRef } from '@angular/core';
import { CommonService } from '../common.service';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
import { NavigatorService } from 'src/app/shared/navigator/navigator.service';
import { DataproviderService } from 'src/app/dataprovider.service';

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss', './thanks.component.responsive.scss'],
  host: {
    class: 'center-route-content'
  }
})
export class ThanksComponent implements OnInit{

  videoURL = "../assets/video/thanks.mp4";

  title: string = "b2c.IDS_THANKS";
  subtitle: string = "b2c.IDS_THANKS_SUB";
  question: string = "b2c.IDS_THANKS_QUE";
  activePage: string = "thanks";
  nextPage: string = "";

  fromSummaryView:boolean = false;
  fromReject:boolean = false;

  thanksTitle: string;
  thanksText: string;
  thanksTextBold: string;

  sharewithInstaller: boolean = false;

  constructor(
    private cs: CommonService,
    private renderer: Renderer2,
    private ns: NavigatorService,
    private route: ActivatedRoute,
    private dp: DataproviderService
  ) {
    this.fromSummaryView = this.route.snapshot.data['fromSummaryView'];
    this.fromReject = this.route.snapshot.data['fromReject'];
    if (this.fromSummaryView===true)
    {
      this.thanksTitle = "b2c.IDS_THANKS_ASK_SHARE"
      this.thanksText = "b2c.IDS_THANKS_TEXT_SHARE"
      this.thanksTextBold = ""
    }
    else if(this.fromReject===true){
      this.thanksTitle = "b2c.IDS_THANKS_ASK_REJECT"
      this.thanksText = "b2c.IDS_THANKS_TEXT_REJECT"
      this.thanksTextBold = ""
    }
    else
    {
      this.thanksTitle = "b2c.IDS_THANKS_ASK"
      this.thanksText = "b2c.IDS_THANKS_TEXT"
      this.thanksTextBold = "b2c.IDS_SHARE_PROJECT_TEXT"
    }

    let loc = this.dp.getLocalization();
    if (loc){
      if (loc['ShareWithInstaller']){
        this.sharewithInstaller = true;
      }
    }
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, false, false, false, true, null, true);
  }

  ngOnInit() {
    //this.sendConversionAnalytics();

    /* // hide survey monkey widget //
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.id = 'smcx-sdk';
    s.src = 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdw6cbjE2hXIN3Zo3e5I05grQB3GkpPtqVM7u4ySYhf3G.js';
    s.setAttribute('async', 'true');
    document.body.appendChild(s);
    */
  }

  sendConversionAnalytics(){
    (<any>window).gtag('event', 'conversion', {
      'send_to': 'AW-972722374/IrakCLD67N4BEMah6s8D'
    });
  }

  linkBtnClick(){
    window.open("https://www.bticino.it/smart-home-o-domotica/smart-home/cosa-puo-fare", "_blank");
  }
  goToSharePage() {
    this.ns.navigateRoute("/share");
  }
}
